<template>
    <div
        :class="{'self-end': idx % 2 !== 0, 'md:mr-40': idx % 2 !== 0, 'md:ml-40': idx % 2 === 0, 'flex-row': idx % 2 === 0, 'flex-row-reverse': idx % 2 !== 0 && member.picture && member.picture !== '' }"
        class="rounded-md shadow bg-gray-100 flex flex-wrap p-3 antialiased mb-12 md:mb-24 w-full md:w-1/2 hover:shadow-lg transition-shadow"
        style="min-height: 10rem"
    >
        <div class="md:w-1/3 w-full flex" v-if="member.picture && member.picture !== ''">
            <div
                :class="{'md:ml-auto' : idx % 2 !== 0}"
                class="rounded-full shadow-lg antialiased w-40 h-40 mx-auto md:mx-0 overflow-hidden"
            >
                <img
                    :alt="member.name"
                    :src="member.picture"
                >
            </div>
        </div>

        <div class="md:w-2/3 w-full px-3 flex flex-col justify-between">
            <div class="w-full font-semibold relative pt-3 md:pt-0 mb-4 md:mb-0">
                <div class="text-2xl font-serif text-glm-blue leading-tight">{{ member.name }}</div>
            </div>

            <p class="text-gray-600 text-sm mb-4 md:mb-0">
                {{ member.description }}
            </p>

            <a :href="member.website" class="text-glm-red font-bold hover:underline">
                read more
                <font-awesome-icon :icon="['fad', 'chevron-right']" class="ml-2"></font-awesome-icon>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: ['member', 'idx'],
}
</script>
